import { ref } from 'vue';
import GroupManager from '@/modules/layers/services/GroupManager';
import type { CanvasEx } from '@/typings/canvas';

export const useGroupManager = (canvas?: CanvasEx) => {
    const managerRef = ref<GroupManager | null>(null);

    const init = (c: CanvasEx) => {
        const instance = new GroupManager(c);
        managerRef.value = instance;
        return managerRef.value;
    };

    const get = () => managerRef.value;

    if (canvas) init(canvas);

    return {
        init,
        get,
        manager: managerRef
    } as const;
};

export default useGroupManager;
